(function () {
  var REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var LERP = REDUCE ? 1 : 0.22;

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function initCharm(root) {
    var charm = root.querySelector("[data-beyoo-charm]");
    if (!charm || charm.dataset.beyooBound === "1") return;
    charm.dataset.beyooBound = "1";

    var dragging = false;
    var pointerId = null;
    var offsetX = 0;
    var offsetY = 0;
    var targetX = 0;
    var targetY = 0;
    var currX = 0;
    var currY = 0;
    var rot = -6;
    var targetRot = -6;
    var lastX = 0;
    var raf = 0;

    function placeInitial() {
      var canvas = root.querySelector(".beyoo-wl__shape--canvas");
      var rect = (canvas || root).getBoundingClientRect();
      var w = charm.offsetWidth || 56;
      var h = charm.offsetHeight || 90;
      // Start over the canvas card (Framer default spot)
      currX = targetX = rect.left + rect.width * 0.78 - w / 2;
      currY = targetY = rect.top + rect.height * 0.16 - h / 2;
      paint();
    }

    function paint() {
      charm.style.transform =
        "translate3d(" + currX + "px," + currY + "px,0) rotate(" + rot + "deg)";
    }

    function tick() {
      currX += (targetX - currX) * LERP;
      currY += (targetY - currY) * LERP;
      rot += (targetRot - rot) * LERP;

      if (
        Math.abs(targetX - currX) < 0.15 &&
        Math.abs(targetY - currY) < 0.15 &&
        Math.abs(targetRot - rot) < 0.05
      ) {
        currX = targetX;
        currY = targetY;
        rot = targetRot;
        paint();
        raf = 0;
        return;
      }

      paint();
      raf = requestAnimationFrame(tick);
    }

    function startAnim() {
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function bounds() {
      var w = charm.offsetWidth || 56;
      var h = charm.offsetHeight || 90;
      // Keep a bit of the sticker on-screen, but allow near-full freedom
      return {
        minX: -w * 0.35,
        maxX: window.innerWidth - w * 0.65,
        minY: -h * 0.2,
        maxY: window.innerHeight - h * 0.65,
      };
    }

    function setTarget(clientX, clientY, withTilt) {
      var b = bounds();
      var nextX = clamp(clientX - offsetX, b.minX, b.maxX);
      var nextY = clamp(clientY - offsetY, b.minY, b.maxY);

      if (withTilt) {
        var dx = clientX - lastX;
        targetRot = clamp(-6 + dx * 0.35, -18, 12);
      }

      targetX = nextX;
      targetY = nextY;
      lastX = clientX;
      startAnim();
    }

    function onPointerDown(e) {
      if (e.button != null && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;
      charm.classList.add("is-dragging");
      document.body.classList.add("beyoo-charm-dragging");

      var rect = charm.getBoundingClientRect();
      offsetX = e.clientX - rect.left;
      offsetY = e.clientY - rect.top;
      // Sync current to rendered position (fixed + transform)
      currX = targetX = rect.left;
      currY = targetY = rect.top;
      lastX = e.clientX;

      try {
        charm.setPointerCapture(e.pointerId);
      } catch (_) {}

      setTarget(e.clientX, e.clientY, false);
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!dragging) return;
      if (pointerId != null && e.pointerId !== pointerId) return;
      setTarget(e.clientX, e.clientY, true);
    }

    function onPointerUp(e) {
      if (!dragging) return;
      if (pointerId != null && e.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      charm.classList.remove("is-dragging");
      document.body.classList.remove("beyoo-charm-dragging");
      targetRot = -6;
      startAnim();
      try {
        charm.releasePointerCapture(e.pointerId);
      } catch (_) {}
    }

    charm.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove, { passive: false });
    window.addEventListener("pointerup", onPointerUp);
    window.addEventListener("pointercancel", onPointerUp);
    window.addEventListener("resize", function () {
      var b = bounds();
      targetX = clamp(targetX, b.minX, b.maxX);
      targetY = clamp(targetY, b.minY, b.maxY);
      startAnim();
    });

    // Wait a frame so layout/images settle
    requestAnimationFrame(placeInitial);
  }

  function boot() {
    document.querySelectorAll("[data-beyoo-waitlist]").forEach(initCharm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
